module.exports = __webpack_public_path__ + "media/bootstrap-icons/brightness-alt-low-fill-661f4d96.svg";